const patterns = {
  YMD: /(?<year>\d{4})[ ./-]+(?<month>\d{1,2})[ ./-]+(?<day>\d{1,2})/,
  DMY: /(?<day>\d{1,2})[ ./-]+(?<month>\d{1,2})[ ./-]+(?<year>\d{4})/,
  MDY: /(?<month>\d{1,2})[ ./-]+(?<day>\d{1,2})[ ./-]+(?<year>\d{4})/,
};

/**
 * Normalize a date-string into YYYY-MM-DD format
 *
 * No guarantee that it is a real date (eg could return 0000-99-00).
 *
 * Parses day and month with or without leading zeroes.
 *
 * Accepts space, dot, forward-slash and hyphen as delimiters between the
 * day/month/year parts.
 *
 * @param date The date to parse
 * @param order The date order, eg 'YMD' for year-month-day
 * @returns a date string on YYYY-MM-DD format, or null if date could not be parsed
 */
export const parseLocalizedDate = (date: string, order: 'YMD' | 'DMY' | 'MDY') => {
  const matches = patterns[order].exec(date);
  if (!matches || !matches.groups) {
    return null;
  }
  const { year, month, day } = matches.groups;
  return `${year}-${month.length === 1 ? '0' : ''}${month}-${day.length === 1 ? '0' : ''}${day}`;
};
